import { useEffect } from 'react'
import { apiClient } from '../lib/api'
import { useAudioBibleStore } from '../stores/audioBibleStore'

const SAVE_INTERVAL_MS = 15_000

/** Persist the user's audio position every 15s while playing, and once on stop. */
export function useAudioResumeSaver() {
  useEffect(() => {
    let interval: ReturnType<typeof setInterval> | null = null

    const save = () => {
      const s = useAudioBibleStore.getState()
      if (!s.bookId || !s.chapter || s.currentVerse == null) return
      void apiClient
        .post('bible/audio/resume/', {
          book_id: s.bookId,
          chapter: s.chapter,
          verse: s.currentVerse,
          position_sec: s.currentPositionSec,
          translation: s.translation,
          voice_id: s.voiceId,
        })
        .catch(() => {
          /* swallow — non-critical */
        })
    }

    const unsub = useAudioBibleStore.subscribe((state, prev) => {
      if (state.status === 'playing' && prev.status !== 'playing') {
        interval = setInterval(save, SAVE_INTERVAL_MS)
      } else if (state.status !== 'playing' && prev.status === 'playing') {
        if (interval) {
          clearInterval(interval)
          interval = null
        }
        save()
      }
    })

    return () => {
      if (interval) clearInterval(interval)
      unsub()
    }
  }, [])
}
